import React from 'react';
import '../cambio.css';

function Siar() {
    return (
        <div>
            <section>
                <div class="text-center">
                    <div class="row align-items-center bgbackg1">
                        <div class="col-4 text-centr">
                            <div className="text-start">
                                <p class="h2 blanco">Cultura de datos</p>
                                <h7 class="blanco">Visualizaciones  interactivas que te permiten descubrir patrones en tu información.</h7>
                            </div>
                        </div>
                        <div class="col-6">
                            <img src="http://siararbal.dyndns.org:8025/Cultura_datos.png" class="img-fluid rounded mx-auto d-block" alt="..."></img>
                        </div>
                    </div>


                    {/*<div class="row justify-content-evenly">
                        <div class="col text-centr2 m-2">
                            <button class="btn reportes_btn" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample6" aria-expanded="true" aria-controls="collapseExample">
                                Dirección General
                            </button>
                        </div>
                    </div>*/}
                    <div class="collapse" id="collapseExample6">
                        <div class="row justify-content-evenly">
                            <div class="col">
                                <a target="_blank" href="https://app.powerbi.com/links/P9biPnPaGr?ctid=8d79ff3b-712a-46ef-b9bd-78ad226a1e79&pbi_source=linkShare">
                                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-04.png" alt="..."></img>
                                </a>
                                <h5>Informe semestral</h5>
                            </div>
                        </div>
                    </div>
                    
                    
                    <div class="row justify-content-evenly color_colum">
                        <div class="col text-centr2 m-2">

                            <button class="btn reportes_btn" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
                                Recursos Humanos
                            </button>
                        </div>
                    </div>
                    <div class="collapse color_colum" id="collapseExample">
                        <div class="row justify-content-evenly">
                            <div class="col">
                                <a target="_blank" href="https://app.powerbi.com/links/-gFrJWHXFa?ctid=8d79ff3b-712a-46ef-b9bd-78ad226a1e79&pbi_source=linkShare">
                                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-04.png" alt="..."></img>
                                </a>
                                <h5>QsQ-El colaborador al centro</h5>
                            </div>
                            
                            <div class="col">
                                <a target="_blank" href="https://app.powerbi.com/links/inovYbQmK2?ctid=8d79ff3b-712a-46ef-b9bd-78ad226a1e79&pbi_source=linkShare">
                                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-04.png" alt="..."></img>
                                </a>
                                <h5>Anticipo de nómina</h5>
                            </div>

                            <div class="col">
                                <a target="_blank" href="https://app.powerbi.com/links/WAvzpyWYrE?ctid=8d79ff3b-712a-46ef-b9bd-78ad226a1e79&pbi_source=linkShare">
                                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-04.png" alt="..."></img>
                                </a>
                                <h5>Fondo de Ahorro</h5>
                            </div>
                            
                        </div>
                        <div class="row justify-content-evenly">
                            <div class="col">
                                <a target="_blank" href="https://app.powerbi.com/links/MoUkDtWRz_?ctid=8d79ff3b-712a-46ef-b9bd-78ad226a1e79&pbi_source=linkShare">
                                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-04.png" alt="..."></img>
                                </a>
                                <h5>Préstamos Administrativos</h5>
                            </div>
                        </div>
                    </div>

                    <div class="row justify-content-evenly">
                        <div class="col text-centr2 m-2">
                            <button class="btn reportes_btn" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample2" aria-expanded="true" aria-controls="collapseExample">
                                Bonos personal operativo
                            </button>
                        </div>
                    </div>
                    <div class="collapse" id="collapseExample2">
                        <div class="row justify-content-evenly">                        
                            <div class="col">
                                <a target="_blank" href="https://app.powerbi.com/links/pQbkp840z6?ctid=8d79ff3b-712a-46ef-b9bd-78ad226a1e79&pbi_source=linkShare">
                                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-04.png" alt="..."></img>
                                </a>
                                <h5>Centro de Operaciones</h5>
                            </div>
                        
                            <div class="col">
                                    <a target="_blank" href="https://app.powerbi.com/links/_hUI92dCrX?ctid=8d79ff3b-712a-46ef-b9bd-78ad226a1e79&pbi_source=linkShare">
                                        <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-04.png" alt="..."></img>
                                    </a>
                                    <h5>Escoltas</h5>
                            </div>
                            <div class="col">
                                <a target="_blank" href="https://app.powerbi.com/links/UIOa45457Q?ctid=8d79ff3b-712a-46ef-b9bd-78ad226a1e79&pbi_source=linkShare">
                                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-04.png" alt="..."></img>
                                </a>
                                <h5>Guardias Edificios</h5>
                            </div>
                            <div class="row justify-content-evenly espacio">
                                <div class="col">
                                    <a target="_blank" href="https://app.powerbi.com/links/3b9k4LxjEY?ctid=8d79ff3b-712a-46ef-b9bd-78ad226a1e79&pbi_source=linkShare">
                                        <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-04.png" alt="..."></img>
                                    </a>
                                    <h5>Guardias Residencias</h5>
                                </div>
                            
                                <div class="col">
                                    <a target="_blank" href="https://app.powerbi.com/links/ATWIKltihv?ctid=8d79ff3b-712a-46ef-b9bd-78ad226a1e79&pbi_source=linkShare">
                                        <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-04.png" alt="..."></img>
                                    </a>
                                    <h5>PBI Residencias</h5>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="row justify-content-evenly color_colum">
                        <div class="col text-centr2 m-2">
                            <button class="btn reportes_btn" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample3" aria-expanded="true" aria-controls="collapseExample">
                                Centro de Operaciones
                            </button>
                        </div>
                    </div>
                    <div class="collapse color_colum" id="collapseExample3">
                        <div class="row justify-content-evenly">
                            <div class="col">
                                <a target="_blank" href="https://app.powerbi.com/links/vvpN2kI46Q?ctid=8d79ff3b-712a-46ef-b9bd-78ad226a1e79&pbi_source=linkShare">
                                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-04.png" alt="..."></img>
                                </a>
                                <h5>Asignación de recursos Comisiones Foráneas</h5>
                            </div>
                            <div class="col">
                                <a target="_blank" href="https://app.powerbi.com/links/l_VEhVSaDh?ctid=8d79ff3b-712a-46ef-b9bd-78ad226a1e79&pbi_source=linkShare">
                                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-04.png" alt="..."></img>
                                </a>
                                <h5>Incidencias por monitoreo del NCO</h5>
                            </div>
                            <div class="row justify-content-evenly">
                                <div class="col">
                                    <a target="_blank" href="https://app.powerbi.com/links/xt_DcIWbyk?ctid=8d79ff3b-712a-46ef-b9bd-78ad226a1e79&pbi_source=linkShare">
                                        <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-04.png" alt="..."></img>
                                    </a>
                                    <h5>Incidencia delictiva</h5>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row justify-content-evenly">
                        <div class="col text-centr2 m-2">
                            <button class="btn reportes_btn" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample4" aria-expanded="true" aria-controls="collapseExample">
                                Capacitación
                            </button>
                        </div>
                    </div>
                    <div class="collapse" id="collapseExample4">
                        <div class="row justify-content-evenly">
                            <div class="col">
                                <a target="_blank" href="https://app.powerbi.com/links/JTIAskVihG?ctid=8d79ff3b-712a-46ef-b9bd-78ad226a1e79&pbi_source=linkShare">
                                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-04.png" alt="..."></img>
                                </a>
                                <h5>Control de asistencia</h5>
                            </div>
                            
                            <div class="col">
                                <a target="_blank" href="https://app.powerbi.com/links/VwkfHvLcQx?ctid=8d79ff3b-712a-46ef-b9bd-78ad226a1e79&pbi_source=linkShare">
                                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-04.png" alt="..."></img>
                                </a>
                                <h5>Calificación de cursos</h5>
                            </div>

                            <div class="col">
                                <a target="_blank" href="https://app.powerbi.com/links/MV8ckQlYq3?ctid=8d79ff3b-712a-46ef-b9bd-78ad226a1e79&pbi_source=linkShare">
                                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-04.png" alt="..."></img>
                                </a>
                                <h5>Nutrición H</h5>
                            </div>
                        </div>
                        <div class="row justify-content-evenly">
                            <div class="col">
                                <a target="_blank" href="https://app.powerbi.com/links/um8L9jiCT_?ctid=8d79ff3b-712a-46ef-b9bd-78ad226a1e79&pbi_source=linkShare">
                                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-04.png" alt="..."></img>
                                </a>
                                <h5>Nutrición M</h5>
                            </div>
                            <div class="col">
                                <a target="_blank" href="https://app.powerbi.com/links/rNNh58F7n8?ctid=8d79ff3b-712a-46ef-b9bd-78ad226a1e79&pbi_source=linkShare">
                                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-04.png" alt="..."></img>
                                </a>
                                <h5>Nutrición Guardias</h5>
                            </div>
                        </div>

                        
                    </div>

                    <div class="row justify-content-evenly color_colum">
                        <div class="col text-centr2 m-2">
                            <button class="btn reportes_btn" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample5" aria-expanded="true" aria-controls="collapseExample">
                                Contabilidad
                            </button>
                        </div>
                    </div>
                    <div class="collapse color_colum" id="collapseExample5">
                        <div class="row justify-content-evenly">
                            <div class="col">
                                <a target="_blank" href="https://app.powerbi.com/links/gTRMzAIyc7?ctid=8d79ff3b-712a-46ef-b9bd-78ad226a1e79&pbi_source=linkShare">
                                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-04.png" alt="..."></img>
                                </a>
                                <h5>Control de presupuesto</h5>
                            </div>
                        </div>
                    </div>
                        
                    <div class="row justify-content-evenly ">
                        <div class="col text-centr2 m-2">
                            <button class="btn reportes_btn" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample7" aria-expanded="true" aria-controls="collapseExample">
                                Planeación e Innovación
                            </button>
                        </div>
                    </div>
                    <div class="collapse" id="collapseExample7">
                        <div class="row justify-content-evenly">
                            <div class="col">
                                <a target="_blank" href="https://app.powerbi.com/links/iKSsqP9_ER?ctid=8d79ff3b-712a-46ef-b9bd-78ad226a1e79&pbi_source=linkShare">
                                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-04.png" alt="..."></img>
                                </a>
                                <h5>Tickets</h5>
                            </div>
                        </div>
                    </div>
                            
                        
                    <div class="row justify-content-evenly color_colum">
                        <div class="col text-centr2 m-2">
                            <button class="btn reportes_btn" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample8" aria-expanded="true" aria-controls="collapseExample">
                                Mantenimiento y Prevención de Riesgos
                            </button>
                        </div>
                    </div>
                    <div class="collapse color_colum" id="collapseExample8">
                        <div class="row justify-content-evenly">
                            <div class="col">
                                <a target="_blank" href="https://app.powerbi.com/links/RKl92z5Gg4?ctid=8d79ff3b-712a-46ef-b9bd-78ad226a1e79&pbi_source=linkShare">
                                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-04.png" alt="..."></img>
                                </a>
                                <h5>Estatus de botiquín vehículos y servicios</h5>
                            </div>

                            <div class="col">
                                <a target="_blank" href="https://app.powerbi.com/links/h_9fvtouPY?ctid=8d79ff3b-712a-46ef-b9bd-78ad226a1e79&pbi_source=linkShar">
                                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-04.png" alt="..."></img>
                                </a>
                                <h5>Estado del reforzamiento</h5>
                            </div>

                            <div class="col">
                                <a target="_blank" href="https://app.powerbi.com/links/aJmB5nn9Jj?ctid=8d79ff3b-712a-46ef-b9bd-78ad226a1e79&pbi_source=linkShare">
                                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-04.png" alt="..."></img>
                                </a>
                                <h5>Vulnerabilidades</h5>
                            </div>
                        </div>
                        <div class="row justify-content-evenly">
                            <div class="col">
                                <a target="_blank" href="https://app.powerbi.com/links/58KHl0RkNo?ctid=8d79ff3b-712a-46ef-b9bd-78ad226a1e79&pbi_source=linkShare&bookmarkGuid=a9052bd6-8dd6-45b3-a80b-8f0477463b01">
                                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-04.png" alt="..."></img>
                                </a>
                                <h5>Inventario casetas</h5>
                            </div>
                        </div>
                    </div>


                    <div class="row justify-content-evenly">
                        <div class="col text-centr2 m-2">
                            <button class="btn reportes_btn" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample9" aria-expanded="true" aria-controls="collapseExample">
                                Operaciones
                            </button>
                        </div>
                    </div>
                    <div class="collapse" id="collapseExample9">
                        <div class="row justify-content-evenly">
                            
                            <div class="col">
                                <a target="_blank" href="https://app.powerbi.com/links/Sb77oCM3Dm?ctid=8d79ff3b-712a-46ef-b9bd-78ad226a1e79&pbi_source=linkShare">
                                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-04.png" alt="..."></img>
                                </a>
                                <h5>Faltas e incapacidades personal operativo</h5>
                                
                            </div>
                            {/* <div class="col">
                                <a target="_blank" href="https://app.powerbi.com/links/LuNRP31ZgS?ctid=8d79ff3b-712a-46ef-b9bd-78ad226a1e79&pbi_source=linkShare">
                                <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-04.png" alt="..."></img>
                                </a>
                                <h5>
                                    Flota actualizada para la operación
                                </h5>
                            </div> */}
                            <div class="col">
                                <a target="_blank" href="https://app.powerbi.com/links/vamMfowVnd?ctid=8d79ff3b-712a-46ef-b9bd-78ad226a1e79&pbi_source=linkShare">
                                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-04.png" alt="..."></img>
                                </a>
                                <h5>Horas hombre Escoltas</h5>
                            </div>
                        </div>
                        <div class="row justify-content-evenly espacio">
                            
                            
                            <div class="col">
                                <a target="_blank" href="https://app.powerbi.com/links/uj3iY3_TuS?ctid=8d79ff3b-712a-46ef-b9bd-78ad226a1e79&pbi_source=linkShare">
                                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-04.png" alt="..."></img>
                                </a>
                                <h5>Horas hombre Guardias</h5>
                            </div>

                            <div class="col">
                                <a target="_blank" href="https://app.powerbi.com/links/r331_GiLk8?ctid=8d79ff3b-712a-46ef-b9bd-78ad226a1e79&pbi_source=linkShare">
                                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-04.png" alt="..."></img>
                                </a>
                                <h5>Checklist de la supervisión</h5>
                            </div>

                            {/*<div class="col">
                                <a target="_blank" href="https://app.powerbi.com/links/SyMC2wNZy7?ctid=8d79ff3b-712a-46ef-b9bd-78ad226a1e79&pbi_source=linkShare">
                                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-04.png" alt="..."></img>
                                </a>
                                <h5>Ficha del personal-Operaciones</h5>
                        </div>*/}
                            
                        </div>
                    </div>
                        
                    <div class="row justify-content-evenly color_colum">
                        <div class="col text-centr2 m-2">
                            <button class="btn reportes_btn" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample10" aria-expanded="true" aria-controls="collapseExample">
                                Vehículos
                            </button>
                        </div>
                    </div>
                    <div class="collapse color_colum" id="collapseExample10">
                        <div class="row justify-content-evenly">
                            <div class="col">
                                <a target="_blank" href="https://app.powerbi.com/links/FVAZpiU6rU?ctid=8d79ff3b-712a-46ef-b9bd-78ad226a1e79&pbi_source=linkShare">
                                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-04.png" alt="..."></img>
                                </a>
                                <h5>
                                    Flota Arbal
                                </h5>
                            </div>
                            <div class="col">
                                <a target="_blank" href="https://app.powerbi.com/links/v8aaUHNLU4?ctid=8d79ff3b-712a-46ef-b9bd-78ad226a1e79&pbi_source=linkShare">
                                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-04.png" alt="..."></img>
                                </a>
                                <h5>
                                    Mantenimiento de<br></br>unidades <br></br>(Días de taller)
                                </h5>
                            </div>
                            <div class="col">
                                <a target="_blank" href="https://app.powerbi.com/links/OYvgR7o2pH?ctid=8d79ff3b-712a-46ef-b9bd-78ad226a1e79&pbi_source=linkShare">
                                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-04.png" alt="..."></img>
                                </a>
                                <h5>
                                    Litros, distancia y <br></br>rendimiento de la flota
                                </h5>
                            </div>
                        </div>

                        <div class="row justify-content-evenly">
                            <div class="col">
                            <a target="_blank" href="https://app.powerbi.com/links/0wLAKLDXRq?ctid=8d79ff3b-712a-46ef-b9bd-78ad226a1e79&pbi_source=linkShare">
                                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-04.png" alt="..."></img>
                                </a>
                                <h5>
                                    Revisión semanal (Checklist)
                                </h5>
                            </div>

                            <div class="col">
                            <a target="_blank" href="https://app.powerbi.com/links/FQVQLtP5aV?ctid=8d79ff3b-712a-46ef-b9bd-78ad226a1e79&pbi_source=linkShare">
                                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-04.png" alt="..."></img>
                                </a>
                                <h5>
                                    Consumos de combustible (Edenred)
                                </h5>
                            </div>
                        </div>
                    </div>
                        
                    <div class="row justify-content-evenly">
                        <div class="col text-centr2 m-2">
                            <button class="btn reportes_btn" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample11" aria-expanded="true" aria-controls="collapseExample">
                                Seguridad Edificios
                            </button>
                        </div>
                    </div>
                    <div class="collapse" id="collapseExample11">
                        <div class="row justify-content-evenly">
                            <div class="col">
                                <a target="_blank" href="https://app.powerbi.com/links/3j3t14jPwe?ctid=8d79ff3b-712a-46ef-b9bd-78ad226a1e79&pbi_source=linkShare">
                                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-04.png" alt="..."></img>
                                </a>
                                <h5>Ingresos Moliere</h5>
                            </div>
                        </div>  
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Siar
